import React from "react";
import styled, { keyframes } from "styled-components";
import { Device } from "../../../../components/device";
import SafeHtml from "../../../../components/Html/SafeHtml";

//#region Styles
const inAnimation = keyframes`
    from {opacity: 0; transform: translateY(-1rem);}
    to {opacity: 1; transform: translateY(0);}
`;

const TabsWrap = styled.section`
    position: relative;
`;

const TabsNav = styled.nav`
    display: flex;
    overflow-x: scroll;
    margin-bottom: 1rem;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    ${Device.tablet} {
        overflow-x: auto;
    }
`;

const TabsPanel = styled.div`
    padding: 1rem 0;
    transform: translateY(-1rem);
    animation: ${inAnimation} .5s forwards;
`;

const TabsNavButton = styled.button`
    border-radius: 0;
    color: currentColor;
    cursor: pointer;
    display: inline-block;
    font-size: var(--text-sm, .8667rem);
    font-weight: bold;
    letter-spacing: 0.025em;
    margin: 0;
    padding: .5rem 0;
    overflow: hidden;
    user-select: none;
    text-decoration: none;
    text-transform: uppercase;
    vertical-align: middle;
    opacity: .25;
    overflow: hidden;
    position: relative;
    transition: all .2s cubic-bezier(0.4, 0, 0.2, 1);
    &:focus {
        outline: none;
    }
    &:after {
        content:"";
        height: 2px;
        width: 100%;
        background-color: currentColor;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    &:hover,
    &:focus,
    &.active {
        opacity: 1;
        &:after {
            opacity: 1;
        }
    }
`;
//#endregion

interface TabsProps
{
    tabItems?: TabItemsProps[];
}

export interface TabItemsProps
{
    title: string;
    text: string;
}

const Tabs: React.FunctionComponent<TabsProps> = (props) =>
{
    const [tabActive, setTabActive] = React.useState(1);
    const setTabActiveHandler = (tab: number) => () =>
    {
        setTabActive(tab);
    };

    const activeMenuHandler = (tab: number): string =>
    {
        if (tab === tabActive)
        {
            return "active";
        }
        return "";
    };

    const renderTabMenuItems = () =>
    {
        if (!props.tabItems)
        {
            return null;
        }

        return props.tabItems.map((tp, index) =>
            <TabsNavButton key={index} onClick={setTabActiveHandler(index + 1)} className={activeMenuHandler(index + 1)}>{tp.title}</TabsNavButton>);
    };

    const tabPanelRenderHelper = (tp: TabItemsProps, index: number) =>
    {
        if (index === tabActive - 1)
        {
            return (
                <TabsPanel key={index}>
                    <SafeHtml html={tp.text} />
                </TabsPanel>
            );
        }
    };

    const renderTabPanels = () =>
    {
        if (!props.tabItems)
        {
            return null;
        }

        return props.tabItems.map((tp, index) =>
            tabPanelRenderHelper(tp, index));
    };

    return (
        <TabsWrap>
            <TabsNav>
                {renderTabMenuItems()}
            </TabsNav>
            {renderTabPanels()}
        </TabsWrap>
    );
};

export default Tabs;